import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { NotfoundComponent } from './main/notfound/notfound.component';
import {QuickLinkPublicComponent} from './quick-link-public/quick-link-public.component';

const routes: Routes = [
  {path: 'oya', component: QuickLinkPublicComponent},
  {path: 'login', component: LoginComponent},
  // {
  //   path: 'atlas',
  //   //canActivate: [AuthGuard],
  //   loadChildren: './main/main.module#MainModule',
  // },
  {
    path: 'atlas',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./main/main.module').then(m => m.MainModule),
  },
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {path: '**', component: NotfoundComponent},
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
